import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import DataTable from "../../DataTable";

import ActiveComponentContext from "../../../contexts/ActiveComponentContext";
import useOutputReportStore from "../../../store/OutputReport.store";
import {
  extractRowKeys,
  getOutputType,
} from "../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../utils/resources/dataTableCopy";

const TargetPortfolio = () => {
  const reportName = "Target Portfolio*"; // Refer to corresponding API Key
  const data = useOutputReportStore((state) => state.data);
  const reportData = data[reportName];
  const rowKeys = extractRowKeys(reportName, data);
  const excludedColumns = ["Units", "Price", "Security Type"];
  const { reportType } = getOutputType(data);
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView({
    /* Optional options */
    threshold: 0.25,
    trackVisibility: true,
    delay: 100,
  });

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  const getFootnote = ({ reportType }) => {
    if (reportType === "cash") {
      return (
        <>
          {dataTableCopy.unlessOtherwiseStated}
          <br />
          [1]{dataTableCopy.targetPortfolios}
        </>
      );
    }
  };

  // Custom processing of columns
  const columns = Object.entries(reportData)
    .filter((key) => !excludedColumns.includes(key[0]))
    .map((data) => {
      let totalValue;
      if (data[0] === "Security Name") {
        totalValue = `${rowKeys.length} Securities`;
      }
      if (data[0] === "Market Value (USD)") {
        totalValue = Object.values(data[1]).reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          0
        );
      }
      return {
        columnTitle: data[0],
        Total: totalValue || undefined,
        ...data[1],
      };
    });

  const types = {
    Country: null,
    "Dividend Yield (%)": "percent",
    "Market Value (USD)": "currency",
    Sector: null,
    "Security Name": null,
    "Weight (%)": "percent",
  };

  if (!data?.[reportName]) {
    return null;
  }

  return (
    <article ref={ref} id="TargetPortfolio" className="report-article">
      <header className="section-title report-article__header">
        <h1>Target Portfolio[1]</h1>
      </header>
      <div className="report-article__content">
        <DataTable
          name="targetPortfolio"
          reportType={reportType}
          variation="max"
          tableCaption={`${reportName} Data Table`}
          tableRowHeaderKey="Ticker"
          tableRowKeys={[
            ...rowKeys,
            {
              label: "Total",
              key: "Total",
            },
          ]}
          tableColumns={columns}
          tableDataTypes={types}
          formatCellDataBy="column"
          footnote={getFootnote({ reportType })}
        />
      </div>
    </article>
  );
};

export default TargetPortfolio;
